import script from "./Ecommerce.vue?vue&type=script&setup=true&lang=js"
export * from "./Ecommerce.vue?vue&type=script&setup=true&lang=js"

import "./Ecommerce.vue?vue&type=style&index=0&id=4ca7db3c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/helixpay-website/helixpay-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ca7db3c"]])

export default __exports__